import gsap from 'gsap'

export class Navigation {
	constructor() {
		this.navOpen = false
		this.bookingOpen = false
		this.toggle = document.querySelectorAll('[data-toggle-nav]')
		this.toggleBooking = document.querySelectorAll('[data-toggle-booking]')
		this.nav = document.querySelector('.header__nav')
		this.booking = document.querySelector('.custom-booking-dropdown')
		this.items = document.querySelectorAll('.menu-item a')
		this.overlay = document.querySelector('.header__overlay')

		this.toggle.forEach((toggle) => {
			toggle.addEventListener('click', () => {
				this.navOpen ? this.closeNavigation() : this.openNavigation()
			})
		})

		this.toggleBooking.forEach((toggle) => {
			toggle.addEventListener('click', () => {
				this.bookingOpen ? this.closeBooking() : this.openBooking()
			})
		})

		this.items.forEach((link) => {
			link.addEventListener('click', () => this.closeNavigation())
			link.addEventListener('click', () => this.closeBooking())
		})

		this.overlay.addEventListener('click', () => {
			this.closeNavigation()
			this.closeBooking()
		})
	}
	openNavigation() {
		const tl = gsap.timeline()

		tl.to(this.nav, {
			duration: 0.85,
			ease: 'power4.inOut',
			clipPath: 'inset(0% 0% 0% 0%)'
		})

		this.navOpen = true

		document.documentElement.classList.add('nav-open')

		this.closeBooking()
	}
	openBooking() {
		const tl = gsap.timeline()

		tl.to(this.booking, {
			duration: 0.85,
			ease: 'power4.inOut',
			clipPath: 'inset(0% 0% 0% 0%)'
		})

		this.bookingOpen = true

		document.documentElement.classList.add('booking-open')

		this.closeNavigation()
	}
	closeNavigation() {
		const tl = gsap.timeline()

		tl.to(this.nav, {
			duration: 0.85,
			ease: 'power4.inOut',
			clipPath: 'inset(0% 0% 100% 0%)'
		})

		this.navOpen = false

		document.documentElement.classList.remove('nav-open')
	}
	closeBooking() {
		const tl = gsap.timeline()

		tl.to(this.booking, {
			duration: 0.85,
			ease: 'power4.inOut',
			clipPath: 'inset(0% 0% 100% 0%)'
		})

		this.bookingOpen = false

		document.documentElement.classList.remove('booking-open')
	}
	snapCloseNavigation() {}
}

export default () => {}
